import { useState } from "react";
import { useCptRateMutation } from "./useCptRateMutation";
import { CPTType } from "../../codingModule/type/normalizeCodesForUi";

type VoteType = "up" | "down" | null;

export default function useCptVoting(caseId?: string, hospitalId?: string) {
  const { mutate: voteCpt } = useCptRateMutation();

  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);
  const [clickedThumbType, setClickedThumbType] = useState<VoteType>(null);
  const [selectedCpt, setSelectedCpt] = useState<CPTType | null>(null);
  const [selectedCodeType, setSelectedCodeType] = useState<"CPT" | "HCPCS">(
    "CPT",
  );
  const [feedbackText, setFeedbackText] = useState("");

  const handleVoteCpt = (
    cpt: CPTType,
    liked: boolean,
    codeType: "CPT" | "HCPCS",
  ) => {
    if (!caseId || !hospitalId || !cpt.cpt_code) return;
    voteCpt({
      cptId: cpt.cpt_code,
      liked,
      caseId,
      hospitalId,
      apiType: codeType,
    });
  };

  const handleThumbUp = (cpt: CPTType, codeType: "CPT" | "HCPCS") => {
    handleVoteCpt(cpt, true, codeType);
  };

  const handleThumbDown = (cpt: CPTType, codeType: "CPT" | "HCPCS") => {
    if (cpt.additionalFeedback) {
      handleVoteCpt(cpt, false, codeType);
      return;
    }
    setFeedbackModalOpen(true);
    setSelectedCpt(cpt);
    setSelectedCodeType(codeType);
    setClickedThumbType("down");
  };

  const handleCloseModal = () => {
    setFeedbackModalOpen(false);
    setFeedbackText("");
    if (!selectedCpt || !clickedThumbType || !caseId || !hospitalId) return;
    handleVoteCpt(selectedCpt, false, selectedCodeType);
  };

  const handleSubmitFeedback = (feedback: string) => {
    if (
      !selectedCpt ||
      !clickedThumbType ||
      !caseId ||
      !hospitalId ||
      !selectedCpt.cpt_code
    )
      return;
    voteCpt({
      cptId: selectedCpt.cpt_code,
      liked: false,
      additionalFeedback: feedback,
      caseId,
      hospitalId,
      apiType: selectedCodeType,
    });
    setFeedbackModalOpen(false);
    setFeedbackText("");
  };

  return {
    feedbackModalOpen,
    feedbackText,
    setFeedbackText,
    handleThumbUp,
    handleThumbDown,
    handleCloseModal,
    handleSubmitFeedback,
  };
}
